export const getFileName = (fileName: string) => {
    if (fileName.indexOf(".") !== -1) {
        fileName = fileName.substring(0, fileName.lastIndexOf(".")) + ".";
    }

    return fileName;
};

export const getFileExtension = (fileName: string) => {
    if (!fileName) {
        return "";
    }

    const ext = fileName.split(".").reverse()[0];
    return ext === fileName ? "" : ext;
};

const disallowFileExtensions = ["html", "htm", "svg", "xml", "svgz", "xhtml", "xht", "xhtm"];

export const checkAllowFileToRender = (filename: string) => {
    return !disallowFileExtensions.includes(getFileExtension(filename));
};
